<template>
  <div class="page page__has-bar">
    <div class="page__bd">
      <custom-layout class="weui-cells" :view-config="customViewConfig">
        <date-field slot="va_date" :label="customLabel.va_date || '收料日期'"  v-model="form.main.va_date" />
        <div class="weui-cell" slot="va_sendcode">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.va_sendcode || "送货单号"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            <input
              class="weui-input"
              type="text"
              v-model="form.main.va_sendcode"
              placeholder="请输入"
            />
          </div>
        </div>
      </custom-layout>

      <div
        class="weui-cells__group"
        v-for="(item, xindex) in form.items"
        :key="xindex"
      >
        <div class="weui-cells__title">
          <span>产品{{ xindex + 1 }}</span>
          <a
            href="javascript:;"
            class="header-tool"
            @click="removeItem(xindex)"
          >
            <span>删除</span>
          </a>
        </div>
        <custom-layout
          class="weui-cells"
          :view-config="customViewConfig"
          position="detail1"
        >
          <div class="weui-cell" slot="vad_qty">
            <div class="weui-cell__hd">
              <label for class="weui-label">{{
              customLabel.vad_qty || "收料数量"
            }}</label>
            </div>
            <div class="weui-cell__bd">
              <input
                class="weui-input"
                type="number"
                v-model="item.vad_qty"
                placeholder="请填写"
              />
            </div>
            <div class="weui-cell__ft">{{ item.pr_unit }}</div>
          </div>
          <warehouse-field v-model="item.vad_whname" @select="onItemSelectWarehouse($event, item)" />
          <div class="weui-cell" slot="vad_madein">
            <div class="weui-cell__hd">
              <label for class="weui-label">{{
              customLabel.vad_madein || "产地"
            }}</label>
            </div>
            <div class="weui-cell__bd">
              <input
                class="weui-input"
                type="text"
                v-model="item.vad_madein"
                placeholder="请填写"
              />
            </div>
          </div>
          <div class="weui-cell" slot="vad_remark">
            <div class="weui-cell__hd">
              <label for class="weui-label">{{
              customLabel.vad_remark || "备注"
            }}</label>
            </div>
            <div class="weui-cell__bd">
              <input
                class="weui-input"
                type="text"
                v-model="item.vad_remark"
                placeholder="请填写"
              />
            </div>
          </div>
          <a
            href="javascript:"
            v-if="xindex == form.items.length - 1"
            class="weui-cell weui-cell_link"
            @click="addItem"
          >
            <div class="weui-cell__bd">添加更多</div>
          </a>
        </custom-layout>
      </div>
      <div class="weui-cells">
        <file-field v-model="form.main.va_attach" ref="va_attach" />
      </div>
    </div>

    <div class="footer-bar weui-dialog__ft">
      <a
        href="javascript:;"
        class="weui-dialog__btn weui-dialog__btn_primary"
        @click="save"
        >提交</a
      >
      <a
        href="javascript:;"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="$router.back()"
        >取消</a
      >
    </div>
  </div>
</template>

<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
import DateField from "@/components/field/DateField.vue";
import FileField from "@/components/field/FileField.vue";
import WarehouseField from "@/components/field/WarehouseField.vue";
import process from "@/mixins/process.js";

export default {
  components: {
    CustomLayout,
    DateField,
    FileField,
    WarehouseField
  },
  mixins: [process],
  data() {
    return {
      baseUrl: "/api/storage/purcverifyapply",
      codeField: "va_code",
      statusField: "va_statuscode",
      caller: "PurcVerifyApply",
      xtype: "stock-purcVerifyApply-formpanel",
      form: {
        main: {

        },
        items: [
          {
            vad_qty: 0
          },
        ],
      },
    };
  },
  created() {
    this.getData();
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.getData();
    });
  },
  methods: {
    getData() {
      var me = this,
        id = me.$route.query.id;
      if (id) {
        me.f_get(function () {}, id);
      }
    },
    onItemSelectWarehouse(selection, item) {
      item.vad_whid = selection.id;
      item.vad_whcode = selection.wh_code;
    },
    /**
     * 保存
     */
    save() {
      var me = this,
        main = me.form.main,
        items = me.form.items,
        checked;
      if (!main.va_date) {
        me.$weui.topTips("请选择收料日期", 2000);
      } else if (!main.va_sendcode) {
        me.$weui.topTips("请填写送货单号", 2000);
      } else {
        var count = 0
        items.forEach(function (item) {
          if (!item.vad_whname) {
            me.$weui.topTips(`第${count + 1}行仓库未选择`, 2000);
            return false;
          } else {
            count++;
            item.vad_pdno = count;
          }
        });
        checked = count == items.length;
      }

      if (checked) {
        me.p_save();
      }
    },
    /**
     * 删除行
     */
    removeItem(index) {
      var me = this,
        items = me.form.items;
      if (items.length == 1) {
        me.$weui.topTips("请至少保留一行", 2000);
      } else {
        let id = items[index].id;

        me.$loading({
          url: '/api/storage/purcverifyapply/deleteDetail/' + id + '?caller=PurcVerifyApply',
          method: 'POST'
        }).then(function (res) {
          if (res.success) {
            items.splice(index, 1);
          } else {
            me.$weui.topTips("删除失败：" + res.message, 3000);
          }
        }).catch(function (err) {
          me.$weui.topTips("删除失败：" + err.message, 3000);
        });
      }
    },
    /**
     * 新增行
     */
    addItem() {
      var me = this,
        items = me.form.items;
      items.push({
        vad_qty: 0
      });
    }
  }
};
</script>